import React, { memo } from 'react';

import {
  PiLock,
  PiUsers,
} from 'react-icons/pi';

import {
  TQServiceRequestVisibilityType,
} from '../../../../types/tqConnectTypes/service-requests';
import { TYPE_LABELS } from '../../constants';

interface Props {
  visibility: TQServiceRequestVisibilityType;
  style?: React.CSSProperties;
}

const ServiceRequestStatusTag: React.FC<Props> = ({
  visibility,
  style = {},
}) => {
  return (
    <div
      className={`tq-service-card__type tq-service-card__type--${visibility}`}
      aria-label={`${visibility} request`}
      style={style}>
      {visibility === 'public' ? (
        <PiUsers size={14} aria-hidden />
      ) : (
        <PiLock size={14} aria-hidden />
      )}
      <span>{TYPE_LABELS[visibility]}</span>
    </div>
  );
};

export default memo(ServiceRequestStatusTag);
